import script from "./LayoutGeneral.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutGeneral.vue?vue&type=script&setup=true&lang=ts"

import "./LayoutGeneral.vue?vue&type=style&index=0&id=34d702d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34d702d6"]])

export default __exports__